import { Coins, Eye } from 'seagull/icons';
import { relationshipSummaryModel } from '~/models';
export const canRequestPaymentMethod = (param)=>{
    let { agreement, isVendor } = param;
    return isVendor && !agreement.isSample && !relationshipSummaryModel.isTerminated(agreement) && (agreement.fundingSource == null || agreement.fundingSource.failedVerification());
};
export const agreementInlineActions = (param)=>{
    let { agreement, isVendor, texts, onView, onAddPaymentMethod, onCompleteVerification } = param;
    const heapId = agreement.isSample ? 'test-agreement' : 'agreement';
    const view = {
        icon: Eye,
        label: texts.view,
        bi: {
            name: 'agreements_view'
        },
        heapId: "".concat(heapId, "-view-btn"),
        onClick: onView
    };
    if (relationshipSummaryModel.canCompleteVerification(agreement)) {
        return [
            {
                icon: Coins,
                label: texts.completeVerification,
                bi: {
                    name: 'agreements_primary_action'
                },
                onClick: onCompleteVerification
            },
            view
        ];
    }
    if (canRequestPaymentMethod({
        agreement,
        isVendor
    })) {
        return [
            {
                icon: Coins,
                label: texts.addPaymentMethod,
                bi: {
                    name: 'agreements_primary_action'
                },
                onClick: onAddPaymentMethod
            },
            view
        ];
    }
    return [
        view
    ];
};
export const makeAgreementInlineActions = (param)=>{
    let { agreementsById, isVendor, texts, onView, onAddPaymentMethod, onCompleteVerification } = param;
    return (row)=>{
        const agreement = agreementsById.get(row.id);
        if (agreement == null) return [];
        return agreementInlineActions({
            agreement,
            isVendor,
            texts,
            onView: ()=>onView(agreement),
            onAddPaymentMethod: ()=>onAddPaymentMethod(agreement),
            onCompleteVerification: ()=>onCompleteVerification(agreement)
        });
    };
};
